// extracted by mini-css-extract-plugin
export var availableItem = "search-bar-alphabet-module--available-item--CYP5P";
export var item = "search-bar-alphabet-module--item--Y3gKM";
export var items = "search-bar-alphabet-module--items--d8ApI";
export var leftArrow = "search-bar-alphabet-module--left-arrow--cAmgS";
export var navigation = "search-bar-alphabet-module--navigation--B3S-e";
export var rightArrow = "search-bar-alphabet-module--right-arrow--Q5tDk";
export var searchBar = "search-bar-alphabet-module--search-bar--P6ytq";
export var selectedItem = "search-bar-alphabet-module--selected-item--Tudcx";